import * as devtool from './RhinoDevTool';

const InertDevTool = function () {
  return null;
};

// Pure selector for the env→component choice: the devtool only mounts in
// development; every other NODE_ENV gets an inert component. Extracted so the
// branch is unit-testable directly, without stubbing NODE_ENV and re-importing
// this module (whose RhinoDevTool value is otherwise fixed at load).
export const selectRhinoDevTool = (nodeEnv = process.env.NODE_ENV) =>
  nodeEnv === 'development' ? devtool.RhinoDevTool : InertDevTool;

export const RhinoDevTool = selectRhinoDevTool();
